package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ClassSectionResponse(
    @SerialName("school_id")
    val schoolId: String? = null,
    @SerialName("academic_year_id")
    val academicYearId: String? = null,
    @SerialName("class_name")
    val className: String? = null,
    @SerialName("section_name")
    val sectionName: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("id")
    val id: String? = null,
    @SerialName("created_at")
    val createdAt: String? = null,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("created_by_name")
    val createdByName: String? = null,
    @SerialName("created_by_id")
    val createdById: String? = null,
    @SerialName("updated_by_name")
    val updatedByName: String? = null,
    @SerialName("updated_by_id")
    val updatedById: String? = null,
    @SerialName("subject_codes")
    val subjectCodes: List<String>? = null,
    @SerialName("subject_link_ids")
    val subjectLinkIds: List<String>? = null
)
